import React from 'react';
import { useField, FieldInputProps } from 'formik';
import { CheckboxInput } from '@guildeducationinc/recess';

/**
 * Formik Field wrapper for Recess 'CheckboxInput'. This requires a few props from Formik to be passed in.
 *
 * @example
 * ```jsx
 * <CheckboxInputField
 *   name={name}
 *   label={label}
 *   onChange={handleChange}
 *   onBlur={handleBlur}
 *   checked={checked}
 *   value={value}
 * />
 * ```
 * Note: 'name', 'label', 'checked', and 'value' are our custom values, whereas
 * 'handleBlur' and 'handleChange' come from Formik props.
 *
 * @packageDocumentation
 */

interface CheckboxFieldProps extends FieldInputProps<string> {
  errors?: string | string[];
  label: string;
  value: string;
  checked: boolean;
}

const CheckboxInputField: React.FC<CheckboxFieldProps> = (props) => {
  const [field, meta, helpers] = useField(props);
  const { onChange } = props;
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event);
    helpers.setValue(event.target.checked);
  };
  return (
    <CheckboxInput
      {...field}
      {...props}
      errors={meta.touched ? meta.error : ''}
      onChange={handleChange}
    />
  );
};

export default CheckboxInputField;
